/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/index.js
// module id = 945
// module chunks = 0